import mixpanel, { RequestOptions } from "mixpanel-browser"
import { createContext } from "react"

/** Initialize Mixpanel tracking, in the browser and on the frontend only. */
if (env.client && !env.admin) {
  mixpanel.init("a875463c55f77166335b71f0a4c027e3", {
    debug: env.dev,
    track_pageview: true,
    persistence: "localStorage",
    cross_subdomain_cookie: true,
  })
  // @ts-ignore
  window.mixpanel = mixpanel
}

export const getMixpanelPayload = (element?: HTMLElement | null) => {
  let payload: Record<string, any> = {}
  if (element) {
    let parent = element as HTMLElement | null
    while (parent && parent.tagName !== "BODY") {
      if (parent.dataset) {
        for (const key in parent.dataset) {
          if (key.startsWith("mixpanel")) {
            const value = parent.dataset[key]
            const finalKey = key.replace(/^mixpanel/, "")
            if (finalKey in payload) continue
            payload[finalKey] = value
          }
        }
      }
      parent = parent.parentElement
    }
  }
  return payload
}

/**
 * Function for tracking events
 * @param label The event name
 * @param params Optional properties for this event, which will be merged into ancestor parameters if an `element` is provided
 * @param element A DOM element to use for collecting data-mixpanel-* parameters, which will be included in the event.
 */
export function trackEvent(
  label: string,
  params: Record<string, any> = {},
  element?: HTMLElement | null,
  options?: RequestOptions,
) {
  if (env.client && !env.admin) {
    const payload = getMixpanelPayload(element)
    Object.assign(payload, params)
    if (env.dev) {
      console.log("%c\x1B[41;93;4m" + label + "\x1B[m", null, payload)
    } else {
    }
    mixpanel.track(label, payload, options)
  }
}

export const TrackingContext = createContext<Record<string, any>>({})
